import { AttachemntFieldValueType } from './attachment.model';
import { FormFieldModel, FormFieldValueType } from './form-field.interface';

export type ActivityDetailsItem = {
  actionId: number;
  actionInstanceId: number;
  attachments: AttachemntFieldValueType[];
  canExclude: boolean;
  canUndoLastAction: boolean;
  ccs: string[];
  createdOn: string;
  entityInstanceId: number;
  fields: ActivityFieldType[];
  hasFields: boolean;
  isDraftState: boolean;
  logo: string;
  message: string;
  nextStateId?: number;
  nextState: string;
  nextStateColor: string;
  nextStateTextColor: string;
  nextStateType: number;
  nextStateTypeId: number;
  notifiedUsers: [];
  preferredFields: {
    isUsed: boolean;
    otherId: number;
    actionId: number;
    key: number;
    value: string;
  }[];
  reboundToDraft: boolean;
  roleAbbr: string;
  roleName: string;
  roleToExcludeIds: [];
  rollbackToDraft: boolean;
  screenId: number;
  sentToUsers: string[];
  stateId?: number;
  state: string;
  stateColor: string;
  stateTextColor: string;
  stateType: number;
  stateTypeId: number;
  tos: string[]; // original field, kept for compatibility
  transitionId: number;
  transitionName: string;
  type: number; // this should have an enum
  user: string;
  userEmail: string;
  userId: number;
};

export type ActivityFieldType<V = FormFieldValueType> = FormFieldModel & {
  aggregateOldValue?: Record<number, string>; // check if always valid
  oldValue?: V;
  value?: V;
};
